import PathBreadcrumbs from './PathBreadcrumbs'

export default PathBreadcrumbs
